import {utilHelper} from "../../_helpers";
const relativeUrl = '/api/addonActivityPrice'

export const addonActivityPriceService = {
    syncProductPrices,
    syncProductsPrices
}

function syncProductPrices(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncProductPrices`, 'PUT',{data})
}

function syncProductsPrices(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncProductsPrices`, 'PUT',{data})
}